import { AppStorage } from './app.storage'
import { storagePrefix } from '../../constants/constants'
import { BroadcastChannel } from 'broadcast-channel'

export const storage = new AppStorage(storagePrefix, sessionStorage)
const email = { name: 'email', value: storage.get('userEmail') }
const oauthToken = { name: 'oauthToken', value: storage.get('oauthToken') }
const refreshToken = {
  name: 'refreshToken',
  value: storage.get('refreshToken')
}
const tokenType = { name: 'tokenType', value: storage.get('tokenType') }
const redirectToPage = {
  name: 'redirectToPage',
  value: storage.get('redirectToPage')
}
const isTokenExpired = {
  name: 'isTokenExpired',
  value: storage.get('isTokenExpired')
}
export const tokens = [
  email,
  oauthToken,
  refreshToken,
  tokenType,
  redirectToPage,
  isTokenExpired
]

export default function StorageListener() {
  const authChannel = new BroadcastChannel('Auth')
  authChannel.postMessage({ message: 'NEW_TAB' })

  authChannel.onmessage = event => {
    onMessageHandler(event, authChannel)
  }
}

export function onMessageHandler(event, authChannel) {
  switch (event.message) {
    case 'NEW_TAB':
      newTabMessage(authChannel)
      break
    case 'EMAIL':
      if (!email.value) {
        storage.set('userEmail', event.value)
      }
      break
    case 'OAUTH':
      if (!oauthToken.value) {
        storage.set('oauthToken', event.value)
      }
      break
    case 'REFRESH_TOKEN':
      if (!refreshToken.value) {
        storage.set('refreshToken', event.value)
      }
      break
    case 'TOKEN_TYPE':
      if (!tokenType.value) {
        storage.set('tokenType', event.value)
      }
      break
    case 'REDIRECT_TO_PAGE':
      if (!redirectToPage.value) {
        storage.set('redirectToPage', event.value)
      }
      break
    case 'IS_TOKEN_EXPIRED':
      if (!isTokenExpired.value) {
        storage.set('isTokenExpired', event.value)
      }
      break
    default:
      break
  }
}

function newTabMessage(authChannel) {
  tokens.forEach(token => {
    const { value } = token
    authChannel.postMessage({ message: getMessage(token.name), value })
  })
  closeListener(authChannel)
}

function getMessage(token) {
  const messages = {
    email: 'EMAIL',
    oauthToken: 'OAUTH',
    refreshToken: 'REFRESH_TOKEN',
    tokenType: 'TOKEN_TYPE',
    isTokenExpired: 'IS_TOKEN_EXPIRED',
    redirectToPage: 'REDIRECT_TO_PAGE'
  }
  return messages[token]
}

function closeListener(authChannel) {
  authChannel.close()
}
